<template>
    <div>
        <div v-if="mobileCheck || windowWidth < 1025" class="mobile-popular-wines">
            <swiper name="HomePopularWines" ref="infoSwiper" :options="swiperOptions">
                <swiper-slide v-for="(item, index) in winesList" :key="index">
                    <v-card class="collection-item collection-item-mobile" v-on:click="() => { goToWineDetails(item) }">
                        <v-card-text>
                            <div :class="{ 'additional-info': true, 'last-item': index===4 }">
                                <div class="wine-name2">
                                    <div class="country-flag" :style="{ background: `url(${item.countryFlagUrl}) no-repeat center` }"></div>
                                    <div v-if="item.displayWineName">
                                      <div class="wine-vintage-name">{{ item.displayWineName }}</div>
                                    </div>
                                    <div v-else-if="item.wineName">
                                      <div class="wine-vintage-name">{{ item.vintage }} {{ item.wineName }}</div>
                                    </div>
                                    <div v-else>
                                      <div class="wine-vintage-name">{{ item.vintage }} {{ item.producerName }}</div>
                                    </div>
                                </div>
                                <div class="wine-region">{{ item.regionName }}, {{ item.appellation }}</div>
                                <div class="wine-color">
                                    <div class="winemarket-winecolor-img" :class="item.colorId == 1 ? 'redwine' : (item.colorId == 2 ? 'whitewine' : 'champagne')" ></div>
                                    <div class="winecolor-tooltip">{{ $t(item.colorId == 1 ? 'red' : (item.colorId == 2 ? 'white' : (item.colorId == 3 ? 'rose' : 'champagne'))) }}{{item.classification !== '' ? `, ${item.classification}` : ''}}</div>
                                </div>

                                <div class="wine-info-row">
                                    <div class="wine-label">{{ $t('case-size') }}:</div>
                                    <div class="wine-value">{{item.size}}</div>
                                </div>
                                <div class="wine-info-row">
                                    <div class="wine-label">Best sell:</div>
                                    <div class="wine-value">{{ formatPrice(item.sellPrice.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) }}</div>
                                </div>
                                <div class="wine-info-row wine-info-last">
                                    <div class="wine-label">Best buy:</div>
                                    <div class="wine-value">{{ formatPrice(item.buyPrice.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) }}</div>
                                </div>

                                <div class="wine-label wine-label-last">{{ $t('last-trade') }}:</div>
                                <div class="wine-last-traded">{{ item.lastTradePrice == null ? '-' : formatPrice(item.lastTradePrice.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) }}</div>
                                <div class="winemarket-change" :class="item.change > -1 ? 'positive' : (item.change == null ? '' : 'negative')">
                                    {{ item.change == null ? '0.00%' : `${item.change.toFixed(2)}%` }}
                                    <div></div>
                                </div>
                                <div class="wine-buttons-wrapper">
                                    <div class="btn-secondary market-btn market-btn-buy ga4-buy-wine" v-on:click="() => selectWine(item, true)">{{ $t('buy') }}</div>
                                    <button class="btn-secondary market-btn" v-on:click="() => selectWine(item, false)" :disabled="checkWineSell(item)">{{ $t('sell') }}</button>
                                </div>
                                <div class="arrow-right"></div>
                                <div class="arrow-left"></div>
                            </div>
                            <div class="wine-bottle" :style="getImgUrl(item.bottlePicture)"></div>
                            <div class="wine-info">
                                <div class="wine-star"></div>
                                <div v-if="item.isEnPrimeur" class="wine-enprimeur">En Primeur</div>
                                <div class="wine-border"></div>
                                <div class="wine-name">
                                    <div class="country-flag" :style="{ background: `url(${item.countryFlagUrl}) no-repeat center` }"></div>
                                    <div class="wine-vintage-name">{{ item.vintage }} {{ item.producerName }}</div>
                                    <div class="wine-vintage-region">{{ item.regionName }}, {{ item.appellation }}</div>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
        </div>
        <div v-else>
            <v-card class="collection-item" v-for="(item, index) in filteredItems" :key="index">
                <v-card-text>
                    <div :class="{ 'additional-info': true, 'last-item': index===4 }">
                        <div class="wine-name2">
                            <div class="country-flag" :style="{ background: `url(${item.countryFlagUrl}) no-repeat center` }"></div>
                            <div v-if="item.displayWineName">
                              <div class="wine-vintage-name">{{ item.displayWineName }}</div>
                            </div>
                            <div v-else-if="item.wineName">
                              <div class="wine-vintage-name">{{ item.vintage }} {{ item.wineName }}</div>
                            </div>
                            <div v-else>
                              <div class="wine-vintage-name">{{ item.vintage }} {{ item.producerName }}</div>
                            </div>
                        </div>
                        <div class="wine-region">{{ item.regionName }}, {{ item.appellation }}</div>
                        <div class="wine-color">
                            <div class="winemarket-winecolor-img" :class="item.colorId == 1 ? 'redwine' : (item.colorId == 2 ? 'whitewine' : 'champagne')" ></div>
                            <div class="winecolor-tooltip">{{ $t(item.colorId == 1 ? 'red' : (item.colorId == 2 ? 'white' : (item.colorId == 3 ? 'rose' : 'champagne'))) }}{{item.classification !== '' ? `, ${item.classification}` : ''}}</div>
                        </div>

                        <div class="wine-info-row">
                            <div class="wine-label">{{ $t('case-size') }}:</div>
                            <div class="wine-value">{{item.size}}</div>
                        </div>
                        <div class="wine-info-row">
                            <div class="wine-label">Best sell:</div>
                            <div class="wine-value">{{ formatPrice(item.sellPrice.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) }}</div>
                        </div>
                        <div class="wine-info-row wine-info-last">
                            <div class="wine-label">Best buy:</div>
                            <div class="wine-value">{{ formatPrice(item.buyPrice.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) }}</div>
                        </div>

                        <div class="wine-label wine-label-last">{{ $t('last-trade') }}:</div>
                        <div class="wine-last-traded">{{ item.lastTradePrice == null ? '-' : formatPrice(item.lastTradePrice.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) }}</div>
                        <div class="winemarket-change" :class="item.change > -1 ? 'positive' : (item.change == null ? '' : 'negative')">
                            {{ item.change == null ? '0.00%' : `${item.change.toFixed(2)}%` }}
                            <div></div>
                        </div>
                        <div class="wine-buttons-wrapper">
                            <div class="btn-secondary market-btn market-btn-buy ga4-buy-wine" v-on:click="() => selectWine(item, true)">{{ $t('buy') }}</div>
                            <button class="btn-secondary market-btn" v-on:click="() => selectWine(item, false)" :disabled="checkWineSell(item)">{{ $t('sell') }}</button>
                        </div>
                        <div class="arrow-right"></div>
                        <div class="arrow-left"></div>
                    </div>
                    <div class="wine-bottle" :style="getImgUrl(item.bottlePicture)" v-on:click="() => { goToWineDetails(item) }"></div>
                    <div class="wine-info" v-on:click="() => { goToWineDetails(item) }">
                        <div class="wine-star-wrapper">
                            <button v-if="isLogged" v-on:click="(event) => toggleFav(event, item)"
                                    :class="item.isFavourite ? 'wine-star active' : 'wine-star'"></button>
                        </div>
                        <div v-if="item.isEnPrimeur" class="wine-enprimeur">En Primeur</div>
                        <div class="wine-border"></div>
                        <div class="wine-name">
                            <div class="country-flag" :style="{ background: `url(${item.countryFlagUrl}) no-repeat center` }"></div>
                            <div v-if="item.wineName">
                              <div class="wine-vintage-name">{{ item.vintage }} {{ item.wineName }}</div>
                            </div>
                            <div v-else>
                              <div class="wine-vintage-name">{{ item.vintage }} {{ item.producerName }}</div>
                            </div>
                            <div class="wine-vintage-region">{{ item.regionName }}, {{ item.appellation }}</div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
import {AWines} from '@/store/actions';
import {mapGetters} from "vuex";
import {GCommon, GPortfolio, GUser, GWines} from "@/store/getters";
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
    name: "HomePopularWines",
    props: ['winesList'],
    components: {
        Swiper,
        SwiperSlide
    },
    directives: {
        swiper: directive
    },
    data () {
        return {
            windowWidth: null,
            swiperOptions: {
                centeredSlides: true,
                slidesPerView: 1.6,
                spaceBetween: 16,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                dynamicBullets: true
            },
            loginLink: '/trading-desk'
        }
    },
    computed: {
        ...mapGetters({
            portfolioSummary: GPortfolio.GET_PORTFOLIO_SUMMARY,
            mobileCheck: GCommon.GET_MOBILE_VERSION,
            isLogged: GUser.GET_USER_LOGGED,
            favWinesList: GWines.GET_FAVOURITE_WINES
        }),
        wineItems() {
            return this.winesList
        },
        filteredItems() {
            return this.wineItems.map(item => {
                let isWineInFavourites = false;
                this.favWinesList.forEach(wine => {
                    if (item.wineId === wine.wineId && item.caseSizeId === wine.caseSizeId) {
                        isWineInFavourites = true;
                    }
                });
                return Object.assign({expanded: false, isFavourite: isWineInFavourites}, item);
            })
        }
    },
    methods: {
        toggleFav(event, wine) {
            event.stopPropagation();
            let currWineId = wine.wineId;
            let currWineCaseSizeId = wine.caseSizeId;
            this.$store.dispatch(AWines.SWITCH_WINE_FAVOURITE, {wineId: wine}).then(x => {
                this.$store.dispatch(AWines.GET_FAVOURITE_WINES).then(
                    this.filteredItems.forEach(wine => {
                        if (wine.wineId === currWineId) {
                            let isWineInFavourites = false;
                            this.favWinesList.forEach(wine => {
                                if (currWineId === wine.wineId && currWineCaseSizeId === wine.caseSizeId) {
                                    isWineInFavourites = true;
                                }
                            });
                            wine.isFavourite = isWineInFavourites;
                            return true
                        }
                    })
                )
            });
        },
        formatPrice(price) {
            return `€ ${price}`
        },
        selectWine(item, isBuy) {
            if (!this.isLogged) {
                this.loginLink = '/wine-details/' + item.wineId + '/' + item.caseSizeId + '/' + item.appellation.toLowerCase().split(' ').join('-') + '-' + (item.classification ? item.classification.toLowerCase().split(' ').join('-') : '') + '-' + (item.colorId === 1 ? 'red' : (item.colorId === 2 ? 'white' : (item.colorId === 3 ? 'rose' : 'champagne'))) + '-' + item.vintage + '-' + item.producerName.toLowerCase().split(' ').join('-');
                this.$nuxt.$emit("showLoginModal", '');
            } else {
                this.$store.dispatch(AWines.SELECT_WINE_ID, { wineId: item.wineId, caseSize: item.caseSizeId, languageId: this.$i18n.locale });
                this.$store.dispatch(AWines.GET_WINE_DETAILS).then(() => {
                    this.$router.push(this.localePath({ path: (isBuy ? '/wine-trading-buy/' : '/wine-trading-sell/') + item.wineId }));
                })
            }
        },
        checkWineSell(wineObj) {
            if (!this.isLogged) {
                return true
            } else {
                let isSellAvailable = true;
                this.portfolioSummary.forEach(wine => {
                    if (wine.wineId === wineObj.wineId && wine.caseSizeId === wineObj.caseSizeId) {
                        isSellAvailable = false;
                    }
                });
                return isSellAvailable
            }
        },
        getImgUrl(imgUrl){
            return "background-image: url('" + imgUrl + "')"
        },
        goToWineDetails(item){
            if (!this.isLogged) {
                this.$store.dispatch(AWines.GET_WINE_DETAILS_NOT_LOGGED, { wineId: item.wineId, caseSize: item.caseSizeId, languageId: this.$i18n.locale }).then(() => {
                    this.$router.push(this.localePath({ path: '/wine-details/' + item.wineId + '/' + item.caseSizeId  + '/' + item.appellation.toLowerCase().split(' ').join('-') + '-' + (item.classification ? item.classification.toLowerCase().split(' ').join('-') : '') + '-' + (item.colorId === 1 ? 'red' : (item.colorId === 2 ? 'white' : (item.colorId === 3 ? 'rose' : 'champagne'))) + '-' + item.vintage + '-' + item.producerName.toLowerCase().split(' ').join('-') }));
                });
            } else {
                this.wineId = item.wineId;
                this.$store.dispatch(AWines.SELECT_WINE_ID, { wineId: item.wineId, caseSize: item.caseSizeId, languageId: this.$i18n.locale });
                this.$store.dispatch(AWines.GET_WINE_DETAILS).then(() => {
                    this.$router.push(this.localePath({ path: '/wine-details/' + item.wineId + '/' + item.caseSizeId + '/' + item.appellation.toLowerCase().split(' ').join('-') + '-' + (item.classification ? item.classification.toLowerCase().split(' ').join('-') : '') + '-' + (item.colorId === 1 ? 'red' : (item.colorId === 2 ? 'white' : (item.colorId === 3 ? 'rose' : 'champagne'))) + '-' + item.vintage + '-' + item.producerName.toLowerCase().split(' ').join('-') }));
                });
            }
        },
        goToLogin() {
            localStorage.setItem('login_path', this.loginLink);
            this.$router.push(this.localePath({ path: '/login' }));
        },
        goToRegister() {
            this.$router.push(this.localePath({ path: '/register' }));
        }
    },
    mounted() {
        this.windowWidth = window.innerWidth;
    },
    created() {
        if (this.isLogged) {
            this.$store.dispatch(AWines.GET_FAVOURITE_WINES)
        }
    }
}
</script>

<style scoped>
    .wine-enprimeur {
        background: #CEA94B;
        text-align: center;
        width: 75px;
        height: 25px;
        font-style: normal;
        font-weight: 400;
        font-size: 11px;
        line-height: 25px;
        color: #FFFFFF;
        position: absolute;
        top: 80px;
        z-index: 9;
    }
    .wine-title {
        position: relative;
    }
    .additional-info {
        display: none;
        padding: 18px;
        background: #FFFFFF;
        border-radius: 8px;
        -webkit-box-shadow: 0 2px 8px 0 rgba(0,0,0,0.75);
        -moz-box-shadow: 0 2px 8px 0 rgba(0,0,0,0.75);
        box-shadow: 0 2px 8px 0 rgba(0,0,0,0.75);
        position: absolute;
        left: calc(100% - 14px);
        z-index: 10;
        width: 260px;
        top: 25px;
    }
    .additional-info.last-item {
        left: unset;
        right: calc(100% - 14px);
    }
    .arrow-right {
        content: '';
        vertical-align: middle;
        margin: auto;
        position: absolute;
        top: 0;
        left: -8px;
        bottom: 0;
        width: 15px;
        height: 15px;
        background: #fff;
        border-top: 1px solid #ccc;
        border-right: 1px solid #ccc;
        -moz-transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
    }
    .arrow-left {
        content: '';
        display: none;
        vertical-align: middle;
        margin: auto;
        position: absolute;
        top: 0;
        right: -8px;
        bottom: 0;
        width: 15px;
        height: 15px;
        background: #fff;
        border-top: 1px solid #ccc;
        border-right: 1px solid #ccc;
        -moz-transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
    }
    .additional-info.last-item .arrow-right {
        display: none;
    }
    .additional-info.last-item .arrow-left {
        display: block;
    }
    .wine-region,
    .wine-color {
        font-family: Roboto, sans-serif;
        font-size: 14px;
        line-height: 23px;
        color: #000000;
        font-weight: 400;
    }
    .wine-color {
        margin-bottom: 5px;
    }
    .wine-info-row {
        margin-top: 4px;
    }
    .wine-value, .wine-label {
        font-family: Roboto, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: normal;
        display: inline-block;
        line-height: 23px;
    }
    .wine-label {
        margin-right: 5px;
        color: #707070;
    }
    .wine-value {
        color: #000000;
    }
    .wine-label-last {
        margin-top: 12px;
    }
    .wine-last-traded {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 19px;
        color: #000000;
    }
    .winemarket-change {
        color: #b2b2b2;
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-size: 16px;
        margin: 2px 0;
        font-weight: normal;
    }
    .winemarket-change.negative div {
        width: 10px;
        height: 15px;
        background-size: contain;
        display: inline-block;
        top: 1px;
        position: relative;
        background: url('../../assets/price-low-10px.svg') no-repeat center;
    }
    .winemarket-change.positive div {
        width: 10px;
        height: 15px;
        background-size: contain;
        display: inline-block;
        top: 1px;
        position: relative;
        background: url('../../assets/price-up-10px.svg') no-repeat center;
    }
    .market-btn {
        height: 40px;
        width: calc((100% - 15px)/2);
        vertical-align: top;
        margin-top: 15px;
        text-align: center;
        padding-left: 0;
        padding-right: 0;
    }
    .market-btn-buy {
        margin-right: 7px;
    }
    .collection-item.theme--light.v-card {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-size: 16px;
        color: #404040;
        font-weight: 700;
        display: inline-block;
        width: calc((100% - 64px)/5);
        margin-right: 16px;
        margin-bottom: 54px;
        vertical-align: top;
        box-shadow: none;
        height: 332px;
        position: relative;
        background: transparent;
    }
    .collection-item-mobile {
        width: 100% !important;
        margin: 0 0 54px !important;
    }
    .collection-item.theme--light.v-card:nth-child(5n+0) {
        margin-right: 0;
    }
    .collection-item:hover {
        cursor: pointer;
    }
    .collection-item:hover .additional-info {
        display: block;
    }
    .wine-info {
        position: absolute;
        width: 100%;
        height: 216px;
        left: 0;
        top: 128px;
        border: 1px solid #CCCCCC;
        box-sizing: border-box;
        border-radius: 8px;
    }
    .wine-star-wrapper {
        width: 24px;
        height: 24px;
        display: block;
        position: absolute;
        right: 20px;
        top: 79px;
        z-index: 9;
    }



    .wine-star {
        background: url('../../assets/star-not-selected.svg') no-repeat center;
        width: 24px;
        height: 24px;
        display: block;
        margin: 0 auto;
        background-size: contain;
    }

    .wine-star:focus,
    .wine-star:active {
        outline: none;
    }

    .wine-star.active,
    .wine-star:hover {
        background: url('../../assets/star-selected.svg') no-repeat center;
        background-size: contain;
    }

    .wine-star.active:hover {
        opacity: 0.8;
    }






    .wine-border {
        position: absolute;
        width: calc(100% - 32px);
        height: 0;
        left: 16px;
        top: 126px;
        border: 1px solid #CCCCCC;
    }
    .wine-name {
        padding: 0 16px;
        position: absolute;
        top: 141px;
        height: 60px;
        overflow: hidden;
        width: 100%;
    }
    .wine-name2 {
        position: relative;
    }
    .country-flag {
        width: 30px;
        height: 15px;
        background-size: contain !important;
        display: block;
        top: 3px;
        position: absolute;
    }
    .wine-vintage-name {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        text-indent: 36px;
        color: #404040;
        max-height: 40px;
        overflow: hidden;
    }
    .wine-bottle {
        position: absolute;
        top: 0;
        width: 169px;
        height: 230px;
        left: calc(50% - 169px/2);
        background-size: contain;
        background-position: center;
        z-index: 2;
    }
    .winemarket-winecolor-img {
        height: 17px;
        width: 9px;
        display: inline-block;
        position: relative;
        background: url('../../assets/rose.png') no-repeat center right;
        background-size: contain;
        margin-right: 8px;
        top: 2px;
    }
    .winemarket-winecolor-img.redwine {
        background: url('../../assets/red.png') no-repeat center right;
        background-size: contain;
    }
    .winemarket-winecolor-img.whitewine {
        background: url('../../assets/white.png') no-repeat center right;
        background-size: contain;
    }
    .winecolor-tooltip {
        display: inline-block;
    }
    .wine-vintage-region {
        font-weight: 300;
        font-size: 12px;
    }
    .bids-offers-modal h3 {
        margin-bottom: 16px;
        font-size: var(--fs-large);
    }
    .btn-bid-proceed {
        font-size: var(--fs-base);
        text-transform: initial;
        font-weight: 300;
        padding: 0 20px !important;
        background: var(--brand);
        color: #ffffff;
    }
    .btn-login {
        background: #004f7f;
        border-color: #004f7f;
    }
    .btn-bid-cancel {
        font-size: var(--fs-base);
        text-transform: initial;
        font-weight: 300;
        padding: 0 20px !important;
    }
    .btn-bid-cancel:hover {
        color: #ffffff;
    }
    .bids-offers-modal {
        padding: 32px 48px;
        text-align: center;
        background: #f6f6f6;
    }
    .bids-offers-modal .warning-icon {
        background: url('../../assets/report_problem-24px.svg') no-repeat center;
        background-size: contain;
        width: 40px;
        height: 40px;
        margin: 0 auto;
    }
    .bids-title svg {
        margin-right: 5px;
        fill: #707070;
    }
    .offers-title svg {
        margin-right: 5px;
        fill: #707070;
    }
    .cancel-bid-body {
        text-align: center;
        justify-content: center;
        font-size: var(--fs-base);
    }

    @media (width: 768px) {
        .wine-star {
            right: 5px
        }
        .collection-item {
            height: 380px;
        }
        .wine-name {
            height: 105px;
        }
        .wine-vintage-name {
            font-size: 14px;
        }
        .wine-info {
            height: 255px;
        }
    }
    @media(max-width: 767px) {
        .swiper-button-next,
        .swiper-button-prev,
        .collection-item:hover .additional-info {
            display: none;
        }
        .home .mobile-popular-wines .swiper-container {
            height: 390px !important;
        }
    }
</style>

<style>
    .collection-item .v-card__text {
        padding: 0;
    }
    .home .mobile-popular-wines .swiper-container {
        height: 500px !important;
    }
</style>
